<style>
.table-dashboard thead tr td {
    background: #1f2248;
    color: #fff;
}
</style>
<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title=" Penyata Pemungut">
            <w-form ref="dform" @validate="search">
                <w-flex justify-space-between class="mb4">
                    <div class="xs4"> 
                        <z-input 
                        label="Tarikh Slip Bank" 
                        name="tarikh_slip_bank" 
                        v-model="cari.tarikh_slip_bank" 
                        type="date"/>
                    </div>
                </w-flex>
                <w-flex justify-space-between class="mb4">
                    <div class="xs4"> 
                        <z-input 
                        label="No. Slip Bank"  
                        name="no_slip_bank" 
                        v-model="cari.no_slip_bank" 
                        />
                    </div>
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
        auth: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_laporan + "kutipan/laporan/penyata_pemungut",
            reload: true,
            status: [
                {
                    value: 1,
                    label: "Aktif",
                },
                {
                    value: 2,
                    label: "Tidak Aktif",
                },
            ],
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/kutipan/laporan/penyata_pemungut" },
                { label: "Laporan", route: "/kutipan/laporan/penyata_pemungut" },
                {
                    label: "Penyata Pemungut",
                    route: "/kutipan/laporan/penyata_pemungut",
                },
            ],
            cari: { tarikh_slip_bank: "", no_slip_bank: "" },
        };
    },
    methods: {
        search() {
            this.$inertia.visit(
                window.location.href = this.service_laporan+'kutipan/laporan/penyata_pemungut?tarikh_slip_bank='+this.cari.tarikh_slip_bank+'&no_slip_bank='+this.cari.no_slip_bank
            );
        },

        reset() {
            this.cari = { tarikh_slip_bank: "", no_slip_bank: ""};
        },
    },
    watch: {},
    mounted() {
        // console.log(this.datas);
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.tarikh_slip_bank == "undefined") {
            this.cari.tarikh_slip_bank = "";
        }
        if (this.cari.no_slip_bank == "undefined") {
            this.cari.no_slip_bank = "";
        }
        // console.log(this.auth.user);
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
